export function getMountedSlideIndexes(activeIndex: number, total: number, windowSize = 1): number[] {
  if (total <= 0) return [];
  const current = Math.min(Math.max(0, activeIndex), total - 1);
  const start = Math.max(0, current - windowSize);
  const end = Math.min(total - 1, current + windowSize);
  const indexes: number[] = [];
  for (let index = start; index <= end; index += 1) {
    indexes.push(index);
  }
  return indexes;
}

export function shouldMountFullSlide(index: number, activeIndex: number, windowSize = 1): boolean {
  return Math.abs(index - activeIndex) <= windowSize;
}
